import { ChevronRight, Target } from 'lucide-react';
import React from 'react';
import { LearningObjective } from '@/types/course.types';

interface ModuleLearningObjectivesProps {
  objectives: LearningObjective[];
  expanded: boolean;
  onToggle: () => void;
  getBloomLevelColor: (level: string) => string;
}

export default function ModuleLearningObjectives({ 
  objectives, 
  expanded, 
  onToggle,
  getBloomLevelColor 
}: ModuleLearningObjectivesProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border">
      <div
        className="flex items-center justify-between p-4 border-b cursor-pointer hover:bg-gray-50 rounded-t-xl"
        onClick={onToggle}
      >
        <h3 className="text-base font-semibold text-gray-900 flex items-center gap-2">
          <Target className="w-4 h-4" />
          Learning Objectives
        </h3>
        <ChevronRight className={`w-4 h-4 text-gray-400 transition-transform ${
          expanded ? 'rotate-90' : ''
        }`} />
      </div>
      {expanded && (
        <div className="p-4 space-y-3">
          {objectives.map((obj, index) => (
            <div key={obj._id || obj.id || index} className="flex items-start gap-2">
              <div className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center text-xs font-medium mt-0.5">
                {index + 1}
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-700">{obj.objective || obj.description || ''}</p>
                <div className="flex flex-wrap items-center gap-2 mt-1">
                  {obj.measurable && (
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                      Measurable
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}